import React from "react";
import "./WeatherForecastDay.css"

export default function WeatherForecastDay(props){
    function maxTemp() {
        let temperature = Math.round(props.data.temperature.maximum);
        return `${temperature}°`
    }  

    function minTemp() {
        let temperature = Math.round(props.data.temperature.minimum);
        return `${temperature}°`
    }

    function day() {
        let date = new Date(props.data.time *1000);
        let day = date.getDay();

        let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

        return days[day];
    }

    return(
        <div className="ForecastDaily"> 
            <div className="ForecastIconContainer">
                 <img className="ForecastIcon" src={props.data.condition.icon_url} alt={props.data.condition.description}/>
            </div>
            <div className="ForecastSummary">
                     <p className="ForecastDay">{day()}</p>
                     <div className="ForecastTemp">
                        <p className="MaxTemp">{maxTemp()}</p>
                        <p className="MinTemp">{minTemp()}</p>
                 </div>
             </div>
        </div>
    )
}